<template>
  <div class="mini-guidelines-header">
    <CofocusLogo style="transform: scale(1.5)" />
    <div class="mini-guidelines-text">Session Guidelines</div>
  </div>
</template>

<script>
import CofocusLogo from "../../../../src/components/Nav/NavComponents/CofocusLogo.vue";

export default {
  name: "HelpCenterTitle",
  components: {
    CofocusLogo,
  },
};
</script>

<style scoped>
.mini-guidelines-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px auto;
  flex-direction: column;
  height: calc(100px / var(--heightResoRatio));;
  padding-top: calc(20px / var(--heightResoRatio));
  box-sizing: border-box;
}
.mini-guidelines-text {
  margin-top: calc(12px / var(--heightResoRatio));
  font-size: calc(22px / var(--widthResoRatio));
  letter-spacing: -0.5px;
}
</style>